import styled from 'styled-components';

export const ToolbarContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 1000;
`;

export const Pill = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 10px;
  padding: 4px;
  gap: 2px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
`;

export const Divider = styled.span`
  width: 1px;
  height: 20px;
  margin: 0 4px;
  background: #e8e8e8;
`;

export const ToolbarButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? '#e8f0fe' : 'transparent')};
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: ${({ $active }) => ($active ? '#dce9fd' : '#f0f0f0')};
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;

    &:hover {
      background: transparent;
    }
  }
`;

export const SectionPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 320px;
  padding: 12px !important;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .sectionTitle {
    font-size: 13px;
    font-weight: 600;
    color: #324150;
  }
`;

export const SectionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .sectionLabel {
    flex-shrink: 0;
    width: 56px;
    font-size: 12px;
    color: #8697a8;
  }

  /*
   * A barra e a bolinha do slider do antd são posicionadas por caminhos
   * diferentes: a barra é absoluta SEM top (cai no static position, que depende
   * do padding-block do slider) e a bolinha vem de um inset-block-start fixo.
   * Qualquer mudança na altura do slider — esticar como flex item, por exemplo —
   * separa os dois: a barra sobe e a bolinha fica no lugar. Ancorar ambos no
   * meio tira a dependência.
   *
   * A bolinha não pode ir por transform: o rc-slider escreve translateX(-50%)
   * inline (é como ele posiciona o valor na horizontal) e o inline vence — daí a
   * margem negativa de meia bolinha.
   */
  .sectionSlider {
    --handle-size: 10px;
    flex: 1;
    min-width: 0;

    .ant-slider-rail,
    .ant-slider-track {
      top: 50%;
      transform: translateY(-50%);
    }

    .ant-slider-handle {
      inset-block-start: 50%;
      margin-block-start: calc(var(--handle-size) / -2);
    }
  }

  .sectionValue {
    flex-shrink: 0;
    width: 40px;
    font-size: 12px;
    text-align: right;
    color: #324150;
  }
`;

export const AxisGroup = styled.div`
  display: flex;
  gap: 4px;
`;

export const AxisButton = styled.button<{ $active: boolean }>`
  flex: 1;
  height: 28px;
  border: 1px solid ${({ $active }) => ($active ? '#1a73e8' : '#e8e8e8')};
  border-radius: 6px;
  background: ${({ $active }) => ($active ? '#e8f0fe' : '#ffffff')};
  color: ${({ $active }) => ($active ? '#1a73e8' : '#324150')};
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;

  &:hover {
    border-color: #1a73e8;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: #f0f0f0;
  }
`;
